import { Step } from '../../shared/components/Stepper/Stepper.types'

export const FULFILLMENT_ORDER_SUBMISSION_KEY = 'fulfillment_order_submission_data'

export const submissionSteps: Step[] = [
  { label: 'Add Items' },
  { label: 'Recipient Details' },
  { label: 'Review & Payment' },
  { label: 'Order Submitted' }
]
